import React from 'react';
import { Link } from 'react-router-dom';
import FormItem from '../../general/formitem.js';

export default class ManageCoursePricing extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            error: "",
            courseName: "",
            basePrice: 0.00,
            prices: []
        }
    }
    componentDidMount()
    {
        this.loadCourse();
    }
    loadCourse()
    {
        this.props.api.send({
            controller: "Course",
            action: "GetCourse",
            method: "post",
            debug: true,
            body: JSON.stringify({courseID: this.props.courseID}),
            success: (result) => {
                if (result.courseID === 0)
                {
                    this.setState({loaded: true, error: "An error occurred while fetching course data."});
                    return;
                }
                result.courseVolumeDiscounts.foEach((cvd) => {
                    cvd.price = cvd.price.toFixed(2);
                })
                this.setState({
                    loaded: true,
                    error: "",
                    courseName: result.courseName,
                    basePrice: result.coursePrice.toFixed(2),
                    prices: result.courseVolumeDiscounts
                })
            },
            error: (err) => {
                this.setState({loaded: false, error: "An error occurred while fetching course data."});
            }
        })
    }
    addPrice(e)
    {
        e.preventDefault();
        var prices = this.state.prices;
        prices.push({userThreshold: 0, price: this.state.basePrice});
        this.setState({prices: prices});
    }
    render()
    {
        const priceRows = this.state.prices.map((p) =>
            <tr key={p.userThreshold}>
                <td>
                    <FormItem label="User Threshold" name="userThreshold" type="text"
                        inputChanged={this.inputChanged} value={p.userThreshold} />
                </td>
                <td>
                    <FormItem label="Price" name="price" type="text"
                        inputChanged={this.inputChanged} value={p.price} />
                </td>
            </tr>
        )
        return (
            <div className="lmsdisplayarea">
                <p>
                    <Link to="/CourseManagement" className="lmsbutton">Back</Link>
                </p>
                { this.state.loaded ? (
                    <div>
                        <h3>Manage Course Pricing - {this.state.courseName}</h3>
                        <p>
                            <strong>Base Price:</strong> ${this.state.basePrice}
                        </p>
                        <p>
                            <Link to="/" className="lmsbutton" onClick={(e) => this.addPrice(e)}>Add Discount</Link>
                        </p>
                        <div className="lmstablecontainer">
                            <table className="lmstable">
                                <tbody>
                                    {priceRows}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/course/management/coursepricingmanagement.js